module.exports = __webpack_public_path__ + "img/spieltagsgewinner.6d965e09.png";